import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ChatCountryCode } from '../../../../sharedServices/chat-experiment.config';

const CHAT_COUNTRIES: ChatCountryCode[] = ['CO', 'MX'];

/** Asks an anonymous visitor for their country when their city cannot be located. */
@Component({
  selector: 'app-mu-chat-country-selector',
  templateUrl: './chat-country-selector.component.html',
  styleUrls: ['./chat-country-selector.component.sass'],
})
export class MuChatCountrySelectorComponent {
  readonly countries = environment.countries.filter(country => CHAT_COUNTRIES.includes(country.geoName as ChatCountryCode));

  @Output() readonly selected = new EventEmitter<ChatCountryCode>();
  @Output() readonly dismissed = new EventEmitter<void>();

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.dismissed.emit();
  }
}
